import React from "react";
import { Flex as NFlex, IFlexProps } from "native-base";

export const Flex: React.FC<IFlexProps> = (props) => {
  return <NFlex {...props} />;
};

export default Flex;
